import { POST,postFile } from "../../index";
export const getExecuteLawNote = (param) => POST("/v1/note/getExecuteLawNote", param);
export const getNoteDetails = (param) => POST("/v1/note/getNoteDetails", param);
export const getCompanyReply = (param) => POST("/v1/note/getCompanyReply", param);
export const getCompanyReplyDetails = (param) => POST("/v1/note/getCompanyReplyDetails", param);
